import React, { useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { Box, Card, Typography, Tabs, Tab } from "@mui/material";
import "react-phone-input-2/lib/bootstrap.css";
import {
  BankAcoount,
  Documentation,
  ProfileSetup,
  TeachingDetails,
} from "../../features";
import Idproof from "../../features/tutor/Idproof";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddTutor = () => {
  const [value, setValue] = useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <MainContainer>
      <div className="main_loyout">
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Profile" {...a11yProps(0)} />
                <Tab label="Bank Account Details" {...a11yProps(1)} />
                <Tab label="Teaching Details" {...a11yProps(2)} />
                <Tab label="Documentation" {...a11yProps(2)} />
                <Tab label="ID Proof" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <ProfileSetup />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <BankAcoount />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TeachingDetails />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <Documentation />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              <Idproof />
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default AddTutor;
